import { render, staticRenderFns } from "./ActionRequiredMessages.vue?vue&type=template&id=b709468e&scoped=true&"
import script from "./ActionRequiredMessages.vue?vue&type=script&lang=ts&"
export * from "./ActionRequiredMessages.vue?vue&type=script&lang=ts&"
import style0 from "./ActionRequiredMessages.vue?vue&type=style&index=0&id=b709468e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b709468e",
  null
  
)

export default component.exports